

import Appleft from './Appleft';
import Appright from './Appright';
import Apptop from './Apptop';
//import './App.css';
//import './swipercss.css'


function App() {
  return (
    <>
    <div className="grid-container">

      <div className="grid-item-1">
        <Apptop/>
      </div>

      <div className="grid-item-2">
        <div className="container text-left">

          <div className="row align-items-start">
          
            <div className="col app-left">
              <Appleft/>
            </div>
            <div className="col app-right">
              <Appright/>
            </div>
          </div>
        </div>
      </div>

  </div>
    </>
  );
}

export default App;
